import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '../interfaces/IError';
import { IRecommendOrderRepository } from '../interfaces/IRecommendOrderRepository';
import { simpleCopy } from '@/utils/deepCopy';

/**
 * 推奨発注情報を持つ集計ID情報を管理する
 */
export class RecommendOrderRepository implements IRecommendOrderRepository {
  private LOCAL_STORAGE_KEY = 'aggregateBusinessIdsForRecommendOrder';
  /**
   * 推奨発注情報を持つ集計ID一覧取得
   */
  get(): INetworkResult<string[], IError> {
    let result: string[] | undefined = undefined;

    // localStorageから集計ID一覧を取得
    const savedItem = localStorage.getItem(this.LOCAL_STORAGE_KEY);
    // 取得した文字列からパース
    if (savedItem) {
      const aggregateBusinessIds: string[] = JSON.parse(savedItem);
      if (aggregateBusinessIds && Array.isArray(aggregateBusinessIds)) {
        result = simpleCopy(aggregateBusinessIds);
      }
    }

    if (result != null) {
      return { status: { type: 'success', data: result } };
    } else {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'notExist',
            message: '推奨発注情報を持つ集計ID一覧が存在しません',
          },
        },
      };
    }
  }

  /**
   * 推奨発注情報を持つ集計ID一覧を登録する
   * @param data - データ
   */
  put(data: string[]): INetworkResult<void, IError> {
    // localStorageに保存
    localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(data));
    return { status: { type: 'success', data: undefined } };
  }
}
